<script setup lang="ts">
import InputSwitch from 'primevue/inputswitch';
import { useAppConfigStore } from '../stores/app-config-store';

const configStore = useAppConfigStore();
</script>

<template>
    <InputSwitch
        v-model="configStore.dismissableMask"
        class="app-layout-dismissable-mask-switch"
    />
</template>
